import { getOmpSearchString } from "@src/api/main/OMPTypes";
import { arrayIsEmpty } from "@src/helpers/array/arrayIsEmpty";
import { wsInvActsServices, type WsInvActContent } from "../../../../../api/wsInvActs";
import { WS_INV_ACT_CONTENT_LIST_INCLUDES } from "../hooks/useWsInvActContentsQuery";

/** Результат поиска элемента состава АИ по обозначению ТМЦ. */
export type WsInvActContentSearchResult =
    | { type: "notFound" }
    | { type: "single"; contentCode: number }
    | { type: "ambiguous"; stockObjSign: string; choices: WsInvActContent[] };

async function searchWsInvActContentByStockObjSign(
    actCode: number,
    stockObjSign: string,
    withIncludes: boolean,
): Promise<WsInvActContent[]> {
    const { items } = await wsInvActsServices.content.load({
        flt: {
            ActInvCodes: [actCode],
            StockobjSign: getOmpSearchString(stockObjSign, { cs: "case_dependent" }),
        },
        include: withIncludes ? WS_INV_ACT_CONTENT_LIST_INCLUDES.include : undefined,
        includeWsDepotCard: withIncludes ? WS_INV_ACT_CONTENT_LIST_INCLUDES.includeWsDepotCard : undefined,
    });

    return items;
}

/**
 * Ищет элемент(ы) состава АИ по обозначению ТМЦ.
 */
export async function resolveWsInvActContentSearch(
    actCode: number,
    stockObjSign: string,
): Promise<WsInvActContentSearchResult> {
    const items = await searchWsInvActContentByStockObjSign(actCode, stockObjSign, false);

    if (arrayIsEmpty(items)) {
        return { type: "notFound" };
    }

    if (items.length === 1) {
        return { type: "single", contentCode: items[0].Code };
    }

    const choices = await searchWsInvActContentByStockObjSign(actCode, stockObjSign, true);

    return { type: "ambiguous", stockObjSign, choices };
}
